import { render } from "./lei-dashboard-details.vue?vue&type=template&id=770fb4c3&ts=true"
import script from "./lei-dashboard-details.vue?vue&type=script&lang=ts"
export * from "./lei-dashboard-details.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__